import React from 'react';
import { ZOOM_URL } from '../../../constants';

/**
 * @module MI-Admin/ResultsIframe
 */
/**
 * @returns {view}
 */
const ResultsIframe = () => (
  <div className="iframe-container m-t-30">
    <iframe src={ZOOM_URL} title="zoom-widget" />
  </div>
);

export default ResultsIframe;
